import { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { browserCoachStore } from "../lib/runningCoach/browserRuntime";

// Only authenticated, same-origin backend media references are renderable.
export default function TrainingMedia({ mediaId, itemId, adminPreview = false, lang = "de", store: providedStore, onStatusChange }) {
  const [resolved, setResolved] = useState(null);
  const [active, setActive] = useState(false);
  const video = useRef(null);
  const statusListener = useRef(onStatusChange);
  useEffect(() => { statusListener.current = onStatusChange; }, [onStatusChange]);
  useEffect(() => {
    let live = true;
    const report = status => { if (live) statusListener.current?.({ mediaId, status }); };
    setResolved(null);
    if (typeof mediaId !== "string" || !/^[a-zA-Z0-9_-]{1,128}$/.test(mediaId)
      || (!(typeof itemId === "string" && itemId) && !(adminPreview === true && itemId == null))) { report("unavailable"); return undefined; }
    report("loading");
    // Only the admin editor explicitly requests an unassigned preview. The API
    // still enforces admin authorization; player/care media stay item-scoped.
    const query = itemId ? `?item_id=${encodeURIComponent(itemId)}` : "";
    api.get(`/training-media/${encodeURIComponent(mediaId)}${query}`).then(({ data }) => {
      const media = data.media;
      const url = media?.content_url;
      if (!live) return;
      if (media?.id === mediaId && media?.status === "ready" && ["video/mp4", "video/webm"].includes(media.mime_type)
        && url === `/api/training-media/${encodeURIComponent(mediaId)}/content${query}`) {
        setResolved({ id: mediaId, itemId, adminPreview, url });
        report("ready");
      } else report("unavailable");
    }).catch(() => { if (live) { setResolved(null); report("unavailable"); } });
    return () => { live = false; };
  }, [mediaId, itemId, adminPreview]);
  useEffect(() => (providedStore || browserCoachStore()).subscribeActivity(value => {
    setActive(value);
    if (value && video.current && !video.current.paused) video.current.pause();
  }), [providedStore]);
  if (!resolved || resolved.id !== mediaId || resolved.itemId !== itemId || resolved.adminPreview !== adminPreview) return null;
  return <figure className="min-w-0 my-2" data-testid="training-video">
    <video ref={video} controls playsInline preload="metadata" src={resolved.url}
      aria-label={lang === "en" ? "Exercise video" : "Übungsvideo"}
      style={{ width: "100%", aspectRatio: "4 / 3", objectFit: "contain", background: "#060a0d", borderRadius: 12 }}
      onPlay={() => { if (active || (providedStore || browserCoachStore()).isActive()) video.current?.pause(); }}
      onError={() => { setResolved(null); statusListener.current?.({ mediaId, status: "unavailable" }); }} />
    {active && <figcaption className="text-xs" style={{ color: "var(--pc-muted)" }}>{lang === "en" ? "Video pauses while the training coach is running." : "Das Video pausiert, solange der Trainingscoach läuft."}</figcaption>}
  </figure>;
}
